import { DYNAMICFORMS_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSDYNAMICFORMS } from "utils/endpoints";
import { http } from "utils/http";

export const  postForm =(  (data) =>   http({
   baseURL:DYNAMICFORMS_URL,
   url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.dynamicForm,
   method: "post",
   data:data
})

.then((respons) => (respons.data))
.catch((err) => {

    return Promise.reject( err);
})
)

export const  deleteForm =(  (formKey) =>   http({
    baseURL:DYNAMICFORMS_URL ,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.dynamicForm,
    method: 'delete',
    params: {
        formKey:formKey
    }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)

export const putForm = (data) => http({
    baseURL:DYNAMICFORMS_URL ,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.dynamicForm,
    method: 'put',
    data:data
    ,params:{
            Confirm:false
        }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

export const getFormByKey = (formKey,ReferenceId=null ,processId=null,parentISCartable=false,formBuiderPage=false) => http({
    baseURL:DYNAMICFORMS_URL,
    url:parentISCartable?ENDPOINTSDYNAMICFORMS.DynamicFormApis.formKeyWorkflow:formBuiderPage?ENDPOINTSDYNAMICFORMS.DynamicFormApis.formKey:ENDPOINTSDYNAMICFORMS.DynamicFormApis.dataFormKey,
    method: 'get',
    params:parentISCartable?{
        formKey: formKey,
        ReferenceId,
        processId,
    }:{
        formKey: formKey,
    }
}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});


export const getAllForms = (pageNumber=null, pageSize=100) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.allForms,
    method: 'get',
     params:{  
        PageNumber: pageNumber,
        PageSize: pageSize,
     }

}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});
export const getDictionaryAvailable = () => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollection,
    method: 'get',

}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});
export const getDataGridAvailable = () => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormDataGrid.browse,
    method: 'get',
    headers: { "Accept-Language": "en" },

}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});



export const checkForm = (formKey) => http({
    baseURL:DYNAMICFORMS_URL ,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.checkEmpty,
    method: 'get',
    params:{
        formKey: formKey
    }

}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

export const CheckExist = (FormKey,FormTitle,Id?) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.CheckExist,
    method: 'get',
    params: {
        Id:Id,
        FormKey:FormKey,
        FormTitle:FormTitle,
    }
}).then((res) => {
    return res.data
}).catch((err) => {
     
    
    return Promise.reject(err);
});

export const getDynamicDictionaryDictionaryApi = (async ( typeName) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollectionPropertiesDictionaryDetails,
    method: 'get',
    params:{
        SystemKey:typeName
        }
    
}).then((res) => {

    return res.data.Data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getDynamicDataGridApi = (async (
   DynamicFormPropertyId
) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormDataGrid.load,
    method: 'get',
    params:{ Id:DynamicFormPropertyId }
    
}).then((res) => {

    return res.data.Data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

function appendParams(PropertySystemKeys:any=null , DataGridSystemKeys:any=null ){
    const params = new URLSearchParams();
        

        if (PropertySystemKeys && Array.isArray(PropertySystemKeys)) {
          PropertySystemKeys.forEach(key => {
            params.append('PropertySystemKeys', key);
          });
        }
        if (DataGridSystemKeys && Array.isArray(DataGridSystemKeys)) {
          DataGridSystemKeys.forEach(key => {
            params.append('DataGridSystemKeys', key);
          });
        }
    return params

}
export const ExportDynamicForm = (async (PropertySystemKeys:any=null , DataGridSystemKeys:any=null ) => await http({
        
        baseURL:DYNAMICFORMS_URL,
        url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.Export,
        method: 'get',
        params:appendParams(PropertySystemKeys ,DataGridSystemKeys ),
        responseType: "blob",
        
    }).then((res) => {
    
        return res
    }).catch((err) => {
     
        return Promise.reject( err);
    })


)





export const ExportForm = (async (formId:any=null  ) => await http({
        
        baseURL:DYNAMICFORMS_URL,
        url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.ExportPackage,
        method: 'get',
        params:{
            formId
        },
        responseType: "blob",
        
    }).then((res) => {
    
        return res
    }).catch((err) => {
     
        return Promise.reject( err);
    })


)
export const importFilesPackage = (fileData) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.ImportPackage,

    method: 'post',
    data: fileData,
    params:{Confirm:false},

    headers: {
        "content-type": "multipart/form-data",
        Accept: "*/*",

    }
}).then((res) => {
    return res.data
}).catch((err) => {
    
    return Promise.reject(err);
});
export const importFiles = (fileData) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.Import,

    method: 'post',
    data: fileData,
    params:{Confirm:false},

    headers: {
        "content-type": "multipart/form-data",
        Accept: "*/*",

    }
}).then((res) => {
    return res.data
}).catch((err) => {
    
    return Promise.reject(err);
});
export const DynamicFormTranslate = (async (
    formKey
 ) => await http({
     baseURL:DYNAMICFORMS_URL,
     url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormTranslate,
     method: 'get',
     params:{formKey }
     
 }).then((res) => {
 
     return res.data.Data
 }).catch((err) => {
  
     return Promise.reject( err);
 })
 
 )
 export const getDataForPrint = ( Id , obj,data=null) => http({
    baseURL:DYNAMICFORMS_URL,

    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.printData,
    method: "post",
    params:{
        id:Id,
        useWarmSignature: true ,
        ...obj
    },
    data
    
}).then((res) => {
     
    return res.data
}).catch((err) => {

    return Promise.reject(err);
});
export const  getControllerLookupConfig =(  () =>   http({
   url: ENDPOINTS.WebApi.controllerLookupConfig,
   method:'get'
})

.then((respons) => (respons.data))
.catch((err) => {

    return Promise.reject( err);
})
)

export const  getDataAsync =(  (baseURL,url) =>   http({
    baseURL,
   url,
   method:'get'
})

.then((respons) => (respons.data))
.catch((err) => {

    return Promise.reject( err);
})
)
